import React from "react";
import { Link } from "react-router-dom";
import "./PaymentSuccess.css"; // Styling file

const PaymentInvalid = () => {
  return (
    <div
      className="payment-success-container"
      style={{ backgroundColor: " #ffd3d3" }}
    >
      <div className="success-card">
        <div className="checkmark" style={{ color: "red", fontSize: "48px" }}>
          ❌
        </div>
        <h1>Payment Invalid Link!</h1>
        <p>Please provide your payment information to complete the checkout.</p>
        {/* Optional: Order ID, Total, etc. */}

        <Link to="/" className="btn-home">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default PaymentInvalid;
